const squint =[
        
    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left"]
    },

    {label:"Type of squint",
    controlType:"radio button",
    options:["Esotropic", "Exotropic", "Hypertropic","Hypotropic"]
    },

    {label:"Description",
    controlType:"text area",
    options:[]
    },

    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]

export default squint